"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userMetadataSchema = void 0;
const yup = __importStar(require("yup"));
const eventDisplayConfigSchema = yup.object().shape({
    flight: yup
        .string()
        .oneOf(['EVENT_NAME', 'CALL_SIGN', 'MISSION_NUMBER', 'MISSION_PROFILE'])
        .notRequired()
        .default('EVENT_NAME'),
    tdy: yup.string().oneOf(['EVENT_NAME']).notRequired().default('EVENT_NAME'),
    ground: yup.string().oneOf(['MISSION_PROFILE']).notRequired().default('MISSION_PROFILE'),
    alertLine: yup.string().oneOf(['ALERT_LINE']).notRequired().default('ALERT_LINE'),
});
exports.userMetadataSchema = yup.object().shape({
    note: yup.string().notRequired(),
    firstLoginTime: yup.number().notRequired(),
    unreadNotificationsCount: yup.number().notRequired(),
    eventDisplayConfig: eventDisplayConfigSchema.notRequired().nullable(),
});
